import { Box, Radio } from '@mui/material'
import { t } from 'i18next'
import EnhancedTable from 'src/components/shared/EnhancedTable/EnhancedTable'
import FilterColumnHeader from 'src/components/shared/EnhancedTable/FilterColumnHeader/FilterColumnHeader'
import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
import Loader from 'src/components/shared/ui/Loader/Loader'
import useFetching from 'src/hooks/useFetching'
import { Contact } from 'src/interfaces'
import { getContacts } from 'src/services/Lexon/ContactsService'

type Props = {
  setSelectedContact: (item: Contact) => void
}

export default function ContactsTable(props: Props): JSX.Element {
  const { setSelectedContact } = props

  const contacts = useFetching({
    key: ['lexon-contacts'],
    fetchFn: () => getContacts()
  })

  const setContacto = row => setSelectedContact(row?.[0]?.original)

  const columns = [
    {
      id: 'selection',
      Header: () => null,
      width: 30,
      Cell: ({ row }) => (
        <>
          <Radio
            {...row.getToggleRowSelectedProps()}
            indeterminate="false"
            title="click para seleccionar"
            inputProps={{ 'aria-label': 'click para seleccionar' }}
            sx={{ padding: '4px', '& .MuiSvgIcon-root': { fontSize: 22 } }}
          />
        </>
      )
    },
    {
      Header: t('components.enhanced_table.header.name'),
      accessor: (item: Contact) =>
        `${item.name} ${item.firstSurname ?? ''} ${item.secondSurname ?? ''}`,
      Filter: FilterColumnHeader,
      filter: 'customFilter'
    },
    {
      Header: t('components.enhanced_table.header.address'),
      accessor: (item: Contact) =>
        `${item.address ?? ''} ${item.postalCode ?? ''} \n ${item.block ?? ''}`,
      // address, postalCode, block, floor, letter,  stair, number
      // falta country, city, state, comunity,
      Filter: FilterColumnHeader,
      filter: 'customFilter'
    },
    {
      Header: t('components.enhanced_table.header.identification'),
      accessor: 'dni',
      Filter: FilterColumnHeader,
      filter: 'customFilter'
    }
    // {
    //   Header: t('components.enhanced_table.header.contact_type'),
    //   accessor: 'type',
    //   align: 'center'
    // }
  ]

  if (contacts.isError) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" padding={2}>
        Se ha producido un error recuperando la información
        <ButtonPrimaryOutlined onClick={() => contacts.refetch()}>
          Intentar de nuevo
        </ButtonPrimaryOutlined>
      </Box>
    )
  }

  if (contacts.isLoading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" padding={2}>
        <Loader />
      </Box>
    )
  }

  return (
    <>
      <EnhancedTable
        variation="modal"
        fixed
        hoverRows
        selectRows
        multiSelect={false}
        columns={columns}
        data={(contacts && contacts.data && contacts.data.items) ?? []}
        toolbar
        noRegistersMessage={t('components.enhanced_table.no_registers.lexon_contacts')}
        required={false}
        onRowSelectStateChange={setContacto}
      />
    </>
  )
}
